<div mat-dialog-title>
  <div class="row">
      <div class="col-11 d-flex auto-complete-equal">
          <p>Document No : {{docNo}} : </p>
          <mat-form-field class="doc-mat-form-field eip-pl-10">
              <mat-select [(ngModel)]="selectedMailType" style="color:white" (selectionChange)="filterMailType($event)">
                  <mat-option [value]="1">Mail</mat-option>
                  <mat-option [value]="2">Transmittal</mat-option>
              </mat-select>
          </mat-form-field>
      </div>
      <div class="col-1">
          <i id="ibtClose" class="fa fa-times-circle pull-right" (click)="closeDialog()" aria-hidden="true"></i>
      </div>
  </div>
</div>
<div mat-dialog-content>
  <kendo-grid [kendoGridBinding]="filteredList" class="eip-pb-20 k-resizable-grid" [sortable]="false" [resizable]="false" [reorderable]="false" [pageable]="false" id="grvStatusList" [resizable]="true">
      <kendo-grid-column title="Sl.No." filterable="false" [width]="60">
          <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
              {{rowIndex+1}}
          </ng-template>
      </kendo-grid-column>
      <kendo-grid-column title="Letter No" field="messageNumber" [width]="150">
          <ng-template kendoGridCellTemplate let-dataItem="dataItem">
              <span class="no-wrap" eipTooltip="{{dataItem.messageNumber}}" eipTooltipPosition="auto">{{dataItem.messageNumber}}</span>
          </ng-template>
      </kendo-grid-column>
      <kendo-grid-column title="Subject" field="messageSubject" [width]="120">
          <ng-template kendoGridCellTemplate let-dataItem>
              <span eipTooltip="{{dataItem.messageSubject}}" eipTooltipPosition="auto">{{dataItem.messageSubject}}</span>
          </ng-template>
      </kendo-grid-column>
      <kendo-grid-column title="From" field="from" [width]="100">
          <ng-template kendoGridCellTemplate let-dataItem="dataItem">
              <span class="no-wrap" eipTooltip="{{dataItem.from}}" eipTooltipPosition="auto">{{dataItem.from}}</span>
          </ng-template>
      </kendo-grid-column>
      <kendo-grid-column title="To" field="to" [width]="100">
          <ng-template kendoGridCellTemplate let-dataItem="dataItem">
              <span class="no-wrap" eipTooltip="{{dataItem.to}}" eipTooltipPosition="auto">{{dataItem.to}}</span>
          </ng-template>
      </kendo-grid-column>
      <kendo-grid-column title="Sent On" field="sentOn" [width]="110">
          <ng-template kendoGridCellTemplate let-dataItem>
              <span class="no-wrap" eipTooltip="{{dataItem.sentOn | date:'dd-MMM-yyyy'}}" eipTooltipPosition="auto">{{dataItem.sentOn | date:'dd-MMM-yyyy'}}</span>
          </ng-template>
      </kendo-grid-column>
      <kendo-grid-column title="Respond By" field="dateOfResponse" [width]="110">
          <ng-template kendoGridCellTemplate let-dataItem>
              <span class="no-wrap" eipTooltip="{{dataItem.respondBy | date:'dd-MMM-yyyy'}}" eipTooltipPosition="auto">{{dataItem.respondBy | date:'dd-MMM-yyyy'}}</span>
          </ng-template>
      </kendo-grid-column>
      <kendo-grid-column title="Status" field="status" [width]="100">
          <ng-template kendoGridCellTemplate let-dataItem="dataItem">
              <span class="no-wrap" eipTooltip="{{dataItem.status}}" eipTooltipPosition="auto">{{dataItem.status}}</span>
          </ng-template>
      </kendo-grid-column>
  </kendo-grid>
</div>